import { Box, Typography } from "@mui/material";
import { Heart } from "lucide-react";
import AddInterest from "./add-interest";


export default function InterestEmptyState() {
  return (
    <Box
      sx={(t) => ({
        backgroundColor: t.nawy.colors.semantic.layer.primary,
        borderRadius: t.nawy.radius.xl,
        px: t.nawy.spacing.md,
        py: t.nawy.spacing.sm,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: t.nawy.spacing.sm,
        height: "100%",
      })}
    >
      <Heart />
      <Box
        sx={(t) => ({
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: t.nawy.spacing.xs,
        })}
      >
        <Typography sx={(t) => t.nawy.typography.english.variants.headline.xs}>
          No interests yet
        </Typography>
        <Typography
          sx={(t) => t.nawy.typography.english.variants.body.md.regular}
        >
          This lead has no interests yet.
        </Typography>
      </Box>
      <AddInterest />
    </Box>
  );
}
